var menuOpen = document.querySelector('.nav-main__icon');
var menuClose = document.querySelector('.nav-main__close');
var subMenuClose = document.querySelector('.sub-menu__close');
var menuItems = document.querySelectorAll('.menu .nav-main-item');
var body = document.querySelector('body');

menuOpen.addEventListener('click', function () {
    document.querySelector('.nav-main').classList.add('nav-main--active');
    body.classList.add('js-menu-active');
});

menuClose.addEventListener('click', function () {
    document.querySelector('.nav-main').classList.remove('nav-main--active');
    body.classList.remove('js-menu-active');
});

subMenuClose.addEventListener('click', function () {
    menuItems.forEach(function (item) {
        this.classList.toggle('js-active')
    });
});

menuItems.forEach(function (item) {
    item.addEventListener('click', function () {
        var activeItem = document.querySelector('.nav-main-item.js-active')
        this.classList.toggle('js-active');

        if (activeItem) {
            activeItem.classList.remove('js-active');
        }
    });
});

// Menu text separation
let htmlItemMenu = document.querySelectorAll('.nav-main-link');
let i = 0;
while (i < htmlItemMenu.length) {
    let stringItem = htmlItemMenu[i].innerText;
    let splitItem = stringItem.split(/(\s+)/);
    let textSpan = '<span>' + splitItem.shift() + '</span>';
    let texteHTML = textSpan + splitItem.join(" ");
    htmlItemMenu[i].innerHTML = texteHTML;
    i++;
}